<app-page-heading [heading]="'Rules Engine Metadata Management'"
                  [hasBackButton]="false">
</app-page-heading>


<div *ngIf="isBusyCounter > 0" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <div *ngIf="dataSource" class="mat-elevation-z8 table-container">

    <table mat-table multiTemplateDataRows matSort
           [dataSource]="dataSource"
           (matSortChange)="sortData($event)">
      
      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell
            class="w-10"></th>
        <td *matCellDef="let row" mat-cell>
          <span [matTooltip]="!isAllowedToEdit() ? 'You do not have permissions to edit' : 'EDIT Rules Engine Metadata'">
            <mat-icon class="table-icon" 
                      [class.disabled]="!isAllowedToEdit()"
                      (click)="isAllowedToEdit() ? onEditRulesEngineMetadata($event, row.rulesEngineMetadataId) : null">
              edit
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RulesEngineMetadataId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            class="w-10">ID
        </th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.RulesEngineMetadataId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Application
        </th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.ApplicationName]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationUrl">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>URL</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.ApplicationUrl]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationVersion">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Version</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.ApplicationVersion]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Updated">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Updated</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.Updated]  | date: 'yyyy/MM/dd HH:mm'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.UpdatedBy">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Updated By</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.UpdatedBy]}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator #rulesEngineMetaDataPaginator
                   [length]="tableControl.length"
                   [pageSize]="tableControl.pageSize"
                   [pageIndex]="0" [pageSizeOptions]="tableControl.pageSizeOptions"
                   (page)="pageChanged($event)">
    </mat-paginator>

  </div>
</div>
